















import { Component, Vue } from 'vue-property-decorator';
import LandingPageLeftSide from '@/components/landingpage/LandingPageLeftSide.vue';
import LandingPageRightSide from '@/components/landingpage/LandingPageRightSide.vue';

@Component({
  components: {
    LandingPageLeftSide,
    LandingPageRightSide,
  },
})
export default class Home extends Vue {
  public beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      // access to component instance via `vm`
      vm.$store.commit('MUTATE_SHOW_FOOTER', true);
    });
  }

  public beforeRouteLeave(to: any, from: any, next: any) {
    this.$store.commit('MUTATE_SHOW_FOOTER', false);
    next();
  }
}
